import FluteAllianceLogo from "../../../assets/General/fluteAllianceLogo.png"

export default function Logo() {
  return (
    <>
      <img src={FluteAllianceLogo} style={{ alignItems: "center", paddingTop: "2%", paddingBottom: "2%" }} alt="Flute Alliance" />
    </>
  );
}
